import React from 'react';
import Div from "@jumbo/shared/Div";
import InputSearch from 'app/components/InputSearch/InputSearch';
import { Typography } from "@mui/material";
import moment from 'moment';
import { NEWS, OTP } from 'app/utils/constants/endPoint';
import { requestApi } from 'app/utils/RestApi';
import { removeToken } from '@jumbo/components/JumboAuthProvider/authHelpers';

const MicrositeNews = () => {
	const [news, setNews] = React.useState([])
	const [dataLogin, setDataLogin] = React.useState({});

	React.useEffect(() => {
		const userdata = localStorage.getItem('userdata')
		if (userdata && !dataLogin?.userLoggedin) {
			const dataLogin = JSON.parse(userdata)
			setDataLogin(dataLogin);
		}

		// removeOtpSession()

		setTimeout(() => {
			window.scrollTo(0, -65);
		}, 200);

		document.querySelector("html").classList.add('overflow-hidden');
	}, []);

	React.useEffect(() => {
		if (dataLogin?.userLoggedin) {
			fetchData()
		}
	}, [dataLogin]);

	const fetchData = async (searchValue = "") => {
		// const otp = sessionStorage.getItem("otp_temp")
		// if(otp) {
		// 	const {data} = await requestApi(OTP.VERIFY_OTP_REF, {
		// 		data: {
		// 			username: localStorage.getItem('username'),
		// 			otp: otp
		// 		}
		// 	})
		// 	if(data.status !== 'success') {
		// 		sessionStorage.removeItem("otp_temp")
		// 		removeToken()
		// 	}
		// }
		let params = {
			pageIndex: 0,
			pageSize: 10,
			refCode: dataLogin?.userLoggedin?.referrerCode
		}

		if (searchValue) {
			params = { ...params, searchValue }
		}

		const response = await requestApi(NEWS.INDEX, {
			params
		});

		if (response.data.status === 'success') {
			const data = response.data.data
			setNews(data)
		}
	}

	// handle search
	const searchNews = (text) => {
		fetchData(text);
	}
	
	return (
		<Div className='content-padding'>
			<Div className='white-container'>
				<Div className='section-header'>News</Div>
				<Div sx={{ p: 3 }}>
					<Div className='flex-justify-start' sx={{ width: '240px' }}>
						{dataLogin?.userLoggedin != null && <InputSearch onBlur={searchNews} />}
					</Div>

					{news.length > 0 ? (
						news.map((newsItem) => (
							<Div className='mt-4' key={newsItem.id}>
								<Div className='p-2'>
									<Typography fontSize={16} fontWeight={600}>{`${moment(newsItem.processDate).format('DD MMM YYYY')}`}</Typography>
									<Typography fontSize={12}>{`Selamat! Lead Anda dengan nama ${newsItem.clientNamePH} telah menjadi nasabah Generali Indonesia dengan Agen Penutup ${dataLogin?.userLoggedin?.agent.name} Terima kasih. Hormat Kami, Generali Indonesia`}</Typography>
								</Div>
							</Div>
						))
					) : (
						<Div sx={{ mt: 2 }}>
							<Div sx={{ mb: 2 }}>
								<Div variant="outlined" sx={{ padding: "12px" }}>
									<Div className='dis-flex-center'>
										<img src={`${process.env.REACT_APP_IMAGES_PATH}/ReffKosong.svg`} width={91} height={91} />
									</Div>
									<Typography sx={{ mt: 1 }} fontSize={14} textAlign={"center"} color={"black"}>Anda tidak memiliki notifikasi saat ini</Typography>
								</Div>
							</Div>
						</Div>
					)}
				</Div>
			</Div>
		</Div>
	);
};

export default MicrositeNews;